import React, { useState } from 'react';
import CodeEditor from '@uiw/react-textarea-code-editor';
import { Box, Tooltip, IconButton } from '@mui/material';
import { ContentCopy } from '@mui/icons-material';

const CodeContent = ({ code, languajeCode = "js", id = "" }) => {
    const [oneCode, setOneCode] = useState(code);
    const [copyText, setCopyText] = useState('copy');

    const handleCopyClick = async() => {
        await navigator.clipboard.writeText(oneCode);
        setCopyText('copied!')
        setTimeout(() => {
            setCopyText('copy')
        }, 1000)
    }
    return (
        <Box sx={{display:'flex', justifyContent:'center', alignContent:'center'}} id={id}>
            
            <CodeEditor
                value={oneCode}
                data-color-mode="dark"
                language={languajeCode}
                placeholder="Please enter JS code."
                onChange={(evn) => setOneCode(evn.target.value)}
                padding={15}
                style={{
                    fontSize: 15,
                    fontFamily: 'ui-monospace,SFMono-Regular,SF Mono,Consolas,Liberation Mono,Menlo,monospace',
                    borderRadius: '8px'
                }}
            />
            <Box position={'absolute'} top='0.2rem' right={0}>
                <Tooltip title={copyText}>
                    <IconButton aria-label='copy'  color='secundary' size="small" onClick={handleCopyClick}>
                        <ContentCopy fontSize="inherit" color='primary'/>
                    </IconButton>
                </Tooltip>
            </Box>
        </Box>
        
    )
}
export default CodeContent